"use strict";
/**
 * @file Deprecated: Do not update this file unless you are updating legacy v1 API style hooks.
 * Add orchestration error codes to packages/state-management/src/modules/api/orchestration/types.ts instead
 * @deprecated
 */
exports.__esModule = true;
exports.GeneralErrorCode = exports.AccountErrorCode = void 0;
var AccountErrorCode;
(function (AccountErrorCode) {
    AccountErrorCode["UnexpectedFailure"] = "A40000";
    AccountErrorCode["OfferAcceptenceTokenExpired"] = "A40001";
})(AccountErrorCode = exports.AccountErrorCode || (exports.AccountErrorCode = {}));
var GeneralErrorCode;
(function (GeneralErrorCode) {
    GeneralErrorCode["RateLimitingError"] = "G20002";
})(GeneralErrorCode = exports.GeneralErrorCode || (exports.GeneralErrorCode = {}));
